

import AlertHandler from "../../../../assets/js/modules/alertHandler";
import FetchHandler from "../../../../assets/js/assets/FetchHandler";

export default class categoryProductUpdate{
    constructor(){
        this.events();
    }
    events(){
        const productCategoryUpdateForm = document.getElementById('productCategoryUpdateForm');
        if(!productCategoryUpdateForm) return;
        productCategoryUpdateForm.addEventListener('submit', this.productCategoryUpdateSave.bind(this));
    }
    async productCategoryUpdateSave(event){
        event.preventDefault();
        try {
            const { status, body } = await FetchHandler.sendFormData(event.target);
            if (status === 200 && body.success) {
                AlertHandler.showAlert(body.message, 'success');
                setTimeout(() => {
                    window.location.href = '/unit/categories-list/';
                }, 300);
            } else {
                AlertHandler.showAlert(body.errors || 'Ein Fehler ist aufgetreten', 'danger');
            }
        } catch (error) {
            AlertHandler.showAlert('Ein Fehler ist aufgetreten: ' + error, 'danger');
        }
    }
}